export default __webpack_public_path__ + "static/media/cup.c5609994.svg";